import type { BranchResponse } from 'api/__GENERATED';

// Maps a single Branch DTO from the generated API client onto the normalized
// `Data.Branch` shape. The DTO exposes `tenantId` but the domain shape
// retains the legacy `companyId` naming — map across explicitly.
function toBranch(dto: BranchResponse) {
  const { id, name, description, tenantId, distributionCenterIds } = dto;

  const branch: Data.Branch = {
    id,
    name,
    description: description ?? '',
    companyId: tenantId,
    distributionCenterIds,
  };

  return branch;
}

export { toBranch };
